import { render, staticRenderFns } from "./AllCustomer.vue?vue&type=template&id=618a8ccc"
import script from "./AllCustomer.vue?vue&type=script&lang=js"
export * from "./AllCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports